export enum GuideTypes {
  NEW_PROFILE_POSITION = 'NEW_PROFILE_POSITION',
  SHOPPING_CART = 'SHOPPING_CART',
}
